"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateWithoutLogging = exports.Direction = void 0;
exports.isNumber = isNumber;
exports.hasNumber = hasNumber;
exports.transformPayoutTypeToStringIcons = transformPayoutTypeToStringIcons;
exports.isObject = isObject;
exports.twoDigit = twoDigit;
exports.getUtcDate = getUtcDate;
exports.getDaysInMonth = getDaysInMonth;
exports.getDropoffPositionLocationUrl = getDropoffPositionLocationUrl;
exports.getMeetingPositionLocationUrl = getMeetingPositionLocationUrl;
exports.getLocationPointUrl = getLocationPointUrl;
const legacy_models_1 = require("@daytrip/legacy-models");
const legacy_models_2 = require("@daytrip/legacy-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
var Direction;
(function (Direction) {
    Direction[Direction["ASC"] = 1] = "ASC";
    Direction[Direction["DESC"] = -1] = "DESC";
})(Direction || (exports.Direction = Direction = {}));
// type checking
// tslint:disable-next-line:no-any
function isNumber(variable) {
    return !isNaN(parseFloat(variable));
}
function hasNumber(value) {
    return /\d/.test(value);
}
function transformPayoutTypeToStringIcons(type) {
    switch (type) {
        case legacy_models_2.PayoutType.Mangopay:
            return "credit-card";
        case legacy_models_2.PayoutType.Paypal:
            return "paypal";
        case legacy_models_2.PayoutType.BankTransaction:
            return "bank";
        case legacy_models_2.PayoutType.Cash:
            return "money";
        case legacy_models_2.PayoutType.Hyperwallet:
            return "h-square";
        case legacy_models_2.PayoutType.Stripe:
            return "cc-stripe";
        default:
            return "question-circle";
    }
}
// tslint:disable-next-line:no-any
function isObject(variable) {
    return Object.prototype.toString.call(variable) === "[object Object]";
}
function twoDigit(x) {
    const output = String(x);
    return output.length === 1 ? `0${output}` : output;
}
function getUtcDate() {
    const now = new Date();
    return new Date(now.getTime() + now.getTimezoneOffset() * 60000);
}
/**
 * month: number - starts with 1
 * year: number
 */
function getDaysInMonth(month, year) {
    return month === 2 ? (year & 3 || (!(year % 25) && year & 15) ? 28 : 29) : 30 + ((month + (month >> 3)) & 1);
}
function getDropoffPositionLocationUrl(dropoffPosition) {
    if (dropoffPosition?.position) {
        return getLocationPointUrl(dropoffPosition.position.latitude, dropoffPosition.position.longitude);
    }
    return "";
}
function getMeetingPositionLocationUrl(meetingPosition) {
    if (meetingPosition?.position) {
        return getLocationPointUrl(meetingPosition.position.latitude, meetingPosition.position.longitude);
    }
    return "";
}
function getLocationPointUrl(latitude, longitude) {
    if (latitude && longitude) {
        return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    }
    return "";
}
const validateWithoutLogging = async (constructor, object, options) => {
    if (!isObject(object)) {
        throw Error(legacy_models_1.RejectionType.ValidationError);
    }
    const classedObject = (0, class_transformer_1.plainToClass)(constructor, object);
    return (0, class_validator_1.validateOrReject)(classedObject, {
        forbidUnknownValues: false,
        ...options,
    });
};
exports.validateWithoutLogging = validateWithoutLogging;
//# sourceMappingURL=utils.js.map